import { getBaseUrlByBackend } from "./getBaseUrlByBackend";

export const getRelativePathForImage = (id: string, width?: number, fileName?: string) => {
    return `/images/${id}/download` + (fileName ? `/${fileName}` : '') + (width ? `?width=${width}` : '')
}

export const getRelativePathForFile = (id: string, fileName?: string) => {
    return `/files/${id}/download` + (fileName ? `/${fileName}` : '');
}

export const getImageUrlByBackend = (backend: string | undefined, id: string | undefined | null, width?: number, fileName?: string) => {
    return backend && id ? getBaseUrlByBackend(backend) + getRelativePathForImage(id, width, fileName) : "";
}

export const getFileUrl = (backend: string | undefined, id: string | undefined | null, fileName?: string) => {
    return backend && id ? getBaseUrlByBackend(backend) + getRelativePathForFile(id, fileName) : "";
}
